import { REQUIRED_FIELD } from 'constants/validations';
import * as yup from 'yup';

export const initialValues = { motive: '', contactMe: true };

export const schema = yup.object().shape({
  motive: yup.string().required(REQUIRED_FIELD),
  contactMe: yup.bool(),
});
